import { Stack } from 'expo-router';
import React from 'react';
import { StyleSheet, View } from 'react-native';
import DesktopNavigation from 'shared/components/vxl/navigation/DesktopNavigation/DesktopNavigation';
import { SMALL_SCREEN_MAX_WIDTH } from 'shared/constants/layout';
import useShouldShowDesktopNavigation from 'shared/hooks/useShouldShowDesktopNavigation';

function MyVaroLayoutWeb() {
  const shouldShowDesktopNavigation = useShouldShowDesktopNavigation();

  return shouldShowDesktopNavigation ? (
    <DesktopNavigation>
      <Stack screenOptions={{ headerShown: false }} />
    </DesktopNavigation>
  ) : (
    <View style={styles.container}>
      <Stack screenOptions={{ headerShown: false }} />
    </View>
  );
}

export default MyVaroLayoutWeb;

const styles = StyleSheet.create({
  container: {
    flex: 1,
    marginHorizontal: 'auto',
    maxWidth: SMALL_SCREEN_MAX_WIDTH,
    width: '100%',
  },
});
